import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '../main.styl'

import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader

Vue.use(Vuetify, {
  iconfont: 'fa',
  theme: {
    primary: '#ba0a15',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c',
    // paco
    paco_rouge: '#ba0a15',
    paco_rouge_fonce: '#58302d',
    paco_rouge_pure: '#f00',
    paco_gris_fonce: '#4f565b',
    paco_rouge_moyen: '#75828f',
    paco_vert: '#cbff00',
    paco_vert_ecran: '#42c125',
    paco_orange: '#ff8400'
  },
  breakpoint: {
    thresholds: {
      xs: 430,
      sm: 960,
      md: 1280,
      lg: 1920
    },
  }
})
